(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biomedix-assessment"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ─── NAMESPACE GLOBALE ─── */
  window.BM = window.BM || {};

  const MODS=[
    {id:'renal',   ico:'🫘',name:'Età renale',          desc:'Funzionalità dei reni',    col:'#0050cc'},
    {id:'pulm',    ico:'🫁',name:'Età polmonare',       desc:'Capacità respiratoria',    col:'#0080e0'},
    {id:'cardio',  ico:'❤️',name:'Età cardiovascolare', desc:'Salute del cuore',         col:'#c02050'},
    {id:'brain',   ico:'🧠',name:'Età cognitiva',       desc:'Benessere cerebrale',      col:'#6030b8'},
    {id:'metabol', ico:'⚗️',name:'Età metabolica',      desc:'Efficienza metabolica',    col:'#008860'},
    {id:'liver',   ico:'🟤',name:'Età epatica',         desc:'Funzionalità del fegato',  col:'#905020'},
    {id:'muscl',   ico:'💪',name:'Età muscolare',       desc:'Forza e recupero',         col:'#c06010'},
    {id:'immune',  ico:'🛡️',name:'Età immunitaria',     desc:'Risposta immunitaria',     col:'#008850'},
    {id:'hormonal',ico:'⚖️',name:'Età ormonale',        desc:'Equilibrio ormonale',      col:'#7030a0'},
    {id:'micro',   ico:'🩸',name:'Età microcircolo',    desc:'Circolazione periferica',  col:'#b01840'},
  ];

  const W=[100,70,35,0];

  const QS={
    renal:[
      {ico:'💧',txt:'Quanta acqua bevi mediamente al giorno?',opts:['Oltre 2 litri','1.5–2 litri','1–1.5 litri','Meno di 1 litro']},
      {ico:'🫘',txt:'Noti gonfiore o ritenzione idrica alle caviglie o al viso?',opts:['Mai','Raramente','Spesso','Quasi ogni giorno']},
      {ico:'🌙',txt:'Ti alzi di notte per urinare?',opts:['Mai','Raramente (1x)','1–2 volte a notte','Più di 2 volte']},
      {ico:'😓',txt:'Hai affaticamento diffuso e inspiegabile?',opts:['No, mai','Raramente','Abbastanza spesso','Quasi sempre']},
      {ico:'🔬',txt:'Hai mai avuto problemi ai reni (calcoli, infezioni, patologie)?',opts:['Mai','Calcoli risolti in passato','Controlli periodici attivi','Patologia renale nota']},
      {ico:'🧂',txt:'Quanto sale e cibi processati consumi?',opts:['Pochissimo, dieta sana','Moderatamente','Spesso','Ogni giorno abbondante']},
      {ico:'💊',txt:'Assumi antidolorifici o antinfiammatori (FANS) frequentemente?',opts:['Mai','Raramente (qualche volta/anno)','Mensilmente','Settimanalmente o più']},
      {ico:'🩺',txt:'Hai mai avuto esami delle urine con proteine, sangue o valori alterati?',opts:['Mai, sempre nella norma','Una volta, poi normalizzato','Occasionalmente','Frequentemente o cronico']},
      {ico:'🏃',txt:'Pratichi attività fisica regolare?',opts:['Sì, 3+ volte a settimana','1–2 volte a settimana','Raramente','Mai o quasi mai']},
      {ico:'🌡️',txt:'Hai mai avuto infezioni urinarie ricorrenti (cistiti, etc.)?',opts:['Mai','Una volta isolata','2–3 volte l\'anno','Molto frequenti, croniche']},
    ],
    pulm:[
      {ico:'🫁',txt:'Come è la tua capacità respiratoria sotto sforzo fisico intenso?',opts:['Ottima, respiro normalmente','Buona, lieve affanno','Limitata, mi affatico presto','Molto limitata, anche a riposo']},
      {ico:'🚬',txt:'Hai mai fumato o fumi tuttora?',opts:['Mai fumato in vita mia','Ho smesso da oltre 5 anni','Fumo occasionale o < 5 anni fa','Fumo attivo attuale']},
      {ico:'🌬️',txt:'Hai episodi di respiro corto nelle attività normali?',opts:['Mai','Raramente','Spesso','Quasi sempre']},
      {ico:'🏭',txt:'Sei esposto a inquinamento, polveri o agenti chimici?',opts:['No, ambiente pulito','Città con traffico','Ambiente lavorativo polveroso','Esposizione chimica intensa']},
      {ico:'💊',txt:'Hai mai avuto diagnosi di asma, BPCO o bronchite cronica?',opts:['Mai','Asma infantile completamente risolto','Bronchite cronica o asma lieve','BPCO o patologia respiratoria cronica']},
      {ico:'🤧',txt:'Quante volte ti ammali di infezioni respiratorie (bronchiti, polmoniti)?',opts:['Raramente (1 ogni 2+ anni)','Una volta l\'anno circa','2–3 volte l\'anno','Molto frequenti, quasi ogni stagione']},
      {ico:'😴',txt:'Hai problemi di apnea notturna o russamento pesante?',opts:['No, mai','Russamento lieve occasionale','Russamento frequente','Apnea notturna diagnosticata']},
      {ico:'🏔️',txt:'Come stai salendo 3–4 piani di scale di corsa?',opts:['Bene, senza problemi','Lieve affanno normale','Affanno significativo','Impossibile, troppo affanno']},
      {ico:'🫀',txt:'Senti spesso oppressione o peso al petto?',opts:['Mai','Raramente','Spesso','Quasi ogni giorno']},
      {ico:'🌿',txt:'Da quanti anni sei esposto a fumo passivo in ambienti chiusi?',opts:['Mai o esposizione nulla','Esposizione minima passata','Qualche anno di esposizione','Molti anni, esposizione intensa']},
    ],
    cardio:[
      {ico:'❤️',txt:'Qual è la tua pressione sanguigna abituale?',opts:['Normale (120/80 o meno)','Leggermente alta (130–140)','Alta, in trattamento farmacologico','Non la misuro mai']},
      {ico:'🏃',txt:'Quanta attività aerobica fai a settimana?',opts:['Oltre 150 min/sett. regolari','75–150 min a settimana','Meno di 75 min/sett.','Zero attività fisica']},
      {ico:'👨‍👩‍👧',txt:'Hai parenti di primo grado con infarto o ictus prima dei 60 anni?',opts:['No, nessun caso','Casi oltre i 65 anni','Casi tra 55–65 anni','Casi prima dei 55 anni']},
      {ico:'😰',txt:'Hai palpitazioni, tachicardia o aritmie?',opts:['Mai','Raramente, episodi isolati','Spesso, senza diagnosi','Diagnosticata aritmia o cardiopatia']},
      {ico:'🥩',txt:'Come descriveresti la tua dieta abituale?',opts:['Mediterranea, ricca di verdure e pesce','Abbastanza sana, qualche eccesso','Irregolare, molti grassi e cibi pronti','Molto ricca di grassi, sale, zuccheri']},
      {ico:'🩺',txt:'Hai mai avuto colesterolo LDL o trigliceridi fuori norma?',opts:['No, sempre nella norma','Borderline, non in terapia','Elevati, in terapia farmacologica','Molto elevati o familiarità genetica']},
      {ico:'😤',txt:'Quanto è alto il tuo livello di stress cronico?',opts:['Basso, gestito bene','Moderato','Alto, difficile da gestire','Molto alto, costante e logorante']},
      {ico:'⚖️',txt:'Qual è il tuo indice di massa corporea (BMI) approssimativo?',opts:['Nella norma (18.5–24.9)','Leggero sovrappeso (25–27)','Sovrappeso (28–30)','Obesità (oltre 30)']},
      {ico:'🍷',txt:'Consumi alcolici regolarmente?',opts:['Mai o quasi mai','Qualche bicchiere a settimana','Quasi ogni giorno (moderato)','Ogni giorno in quantità elevate']},
      {ico:'💤',txt:'Dormi regolarmente 7–8 ore di qualità?',opts:['Sì, sempre','Quasi sempre','Raramente','Mai, sonno molto carente']},
    ],
    brain:[
      {ico:'🧠',txt:'Come valuti la tua capacità di concentrazione prolungata?',opts:['Eccellente, ore senza distrarmi','Buona, con qualche interruzione','Difficoltà frequenti dopo 20–30 min','Molto scarsa, non riesco a concentrarmi']},
      {ico:'😴',txt:'Quante ore di sonno di qualità fai mediamente?',opts:['7–9 ore, mi sveglio riposato','6–7 ore, abbastanza riposante','5–6 ore o sonno molto discontinuo','Meno di 5 ore o insonnia cronica']},
      {ico:'📚',txt:'Mantieni la mente attiva (lettura, studio, puzzle, lingue)?',opts:['Ogni giorno, stimolazione costante','Spesso, qualche volta a settimana','Raramente','Quasi mai, vita mentalmente passiva']},
      {ico:'😤',txt:'Come gestisci lo stress mentale e le preoccupazioni?',opts:['Molto bene, tecniche di gestione','Abbastanza bene','Con difficoltà, spesso ansioso','Molto male, ansia cronica']},
      {ico:'🌀',txt:'Hai episodi di nebbia mentale, confusione o dimenticanze frequenti?',opts:['Mai','Raramente','Spesso','Quasi ogni giorno, sempre']},
      {ico:'🏃',txt:'Fai esercizio fisico regolare (benefico anche per il cervello)?',opts:['Sì, 3+ volte/settimana','1–2 volte a settimana','Raramente','Mai']},
      {ico:'👥',txt:'Hai relazioni sociali attive e stimolanti?',opts:['Sì, vita sociale ricca','Abbastanza, qualche interazione','Poca vita sociale','Quasi isolamento sociale']},
      {ico:'😔',txt:'Soffri di episodi depressivi, ansia persistente o sbalzi d\'umore?',opts:['Mai','Raramente, episodi passeggeri','Spesso','Cronico, in trattamento']},
      {ico:'🍷',txt:'Consumi alcolici frequentemente (neurotossico)?',opts:['Mai o raramente','Qualche occasione a settimana','Quasi ogni giorno','Ogni giorno in quantità']},
      {ico:'📱',txt:'Passi molte ore al giorno davanti agli schermi senza pause?',opts:['No, uso equilibrato','2–3 ore continue max','4–6 ore senza pause','Oltre 6 ore, uso compulsivo']},
    ],
    metabol:[
      {ico:'⚗️',txt:'Il tuo peso corporeo è rimasto stabile (±2 kg) negli ultimi 2 anni?',opts:['Sì, molto stabile','Variazioni di 3–5 kg','Oscillazioni di 5–10 kg','Forti variazioni, oltre 10 kg']},
      {ico:'🍽️',txt:'Come descrivi le tue abitudini alimentari quotidiane?',opts:['Regolari, bilanciate, 3 pasti sani','Abbastanza buone con qualche eccesso','Irregolari, molti fuori pasto','Molto disordinate, pasti saltati/eccessi']},
      {ico:'🩸',txt:'Hai mai avuto glicemia a digiuno alterata o diabete?',opts:['No, sempre < 100 mg/dL','Borderline (100–125 mg/dL)','Diabete tipo 2 in terapia','Diabete con complicazioni']},
      {ico:'💤',txt:'Ti senti pesante, assonnato o stanco dopo i pasti?',opts:['Mai, digestione ottima','Raramente, solo pasti abbondanti','Spesso, anche dopo pasti normali','Quasi sempre, molto pesante']},
      {ico:'⚖️',txt:'Qual è il tuo BMI approssimativo?',opts:['Normo peso (18.5–24.9)','Sovrappeso lieve (25–27)','Sovrappeso (28–30)','Obesità (oltre 30)']},
      {ico:'🏋️',txt:'Pratichi esercizio fisico regolare?',opts:['Sì, 3+ volte/settimana','1–2 volte a settimana','Raramente','Mai o quasi mai']},
      {ico:'🥤',txt:'Consumi bevande zuccherate, succhi o alcolici frequentemente?',opts:['No, solo acqua e tè','Raramente, qualche occasione','Spesso, più volte a settimana','Ogni giorno, abbondanti']},
      {ico:'🩺',txt:'Hai mai avuto colesterolo, trigliceridi o acido urico fuori norma?',opts:['No, sempre nella norma','Borderline','Elevati, in terapia','Molto elevati o sindrome metabolica']},
      {ico:'😴',txt:'Il tuo sonno è regolare e riposante?',opts:['Sì, 7–8 ore di qualità','Abbastanza, qualche notte difficile','Spesso disturbato','Insonnia cronica o meno di 5 ore']},
      {ico:'🌿',txt:'Consumi quotidianamente verdure, legumi e cereali integrali?',opts:['Sì, ad ogni pasto','Spesso, non sempre','Raramente','Quasi mai, dieta povera di fibre']},
    ],
    liver:[
      {ico:'🍷',txt:'Quanti alcolici consumi mediamente a settimana?',opts:['0 (astinente totale)','1–7 unità alcoliche','8–14 unità alcoliche','Oltre 14 unità o consumo quotidiano']},
      {ico:'💊',txt:'Assumi farmaci in modo continuativo (tutti i giorni)?',opts:['No, nessun farmaco','Solo integratori e vitamine','1–2 farmaci cronici','3 o più farmaci cronici (politerapia)']},
      {ico:'😴',txt:'Hai stanchezza intensa e inspiegabile anche dopo riposo?',opts:['No, mai','Raramente','Spesso, mi sento sempre a pezzi','Quasi sempre, debilitante']},
      {ico:'🍔',txt:'Quanti cibi fritti, grassi, processati o fast food consumi?',opts:['Quasi mai, dieta pulita','Qualche volta a settimana','Quasi ogni giorno','Ogni giorno, regime ricco di grassi']},
      {ico:'🔬',txt:'Hai mai avuto GOT, GPT o GGT (transaminasi) elevati negli esami?',opts:['Mai, sempre nella norma','Lieve rialzo transitorio risolto','Alterazioni moderate persistenti','Epatite, steatosi avanzata o cirrosi']},
      {ico:'🤢',txt:'Hai frequente nausea, gonfiore dopo i pasti, digestione lenta?',opts:['No, digestione ottima','Raramente','Spesso, quasi ogni giorno','Quasi sempre, molto fastidioso']},
      {ico:'🩺',txt:'Hai mai ricevuto diagnosi di steatosi epatica (fegato grasso)?',opts:['No, mai','Steatosi lieve in passato, risolta','Steatosi attuale lieve-moderata','Steatosi avanzata o epatopatia cronica']},
      {ico:'⚖️',txt:'Qual è il tuo BMI approssimativo?',opts:['Normo peso (18.5–24.9)','Sovrappeso lieve (25–27)','Sovrappeso-obeso (28–35)','Obesità severa (oltre 35)']},
      {ico:'🥗',txt:'Consumi frutta e verdura fresca ogni giorno?',opts:['Sì, ad ogni pasto','Spesso','Raramente','Quasi mai']},
      {ico:'💧',txt:'Bevi almeno 1.5–2 litri di acqua al giorno?',opts:['Sì, sempre','Quasi sempre','Raramente','Quasi mai, bevo molto poco']},
    ],
    muscl:[
      {ico:'💪',txt:'Quante volte a settimana fai esercizio di forza o resistenza?',opts:['3 o più volte a settimana','1–2 volte a settimana','Meno di una volta','Mai, vita completamente sedentaria']},
      {ico:'🤕',txt:'Hai dolori muscolari, articolari o crampi frequenti?',opts:['No, mai','Raramente dopo sforzo intenso','Spesso anche senza sforzo','Ogni giorno, dolore cronico']},
      {ico:'🔋',txt:'Quanto tempo impieghi a sentirti recuperato dopo uno sforzo fisico?',opts:['24 ore, recupero rapido','1–2 giorni','3–5 giorni','Non mi recupero, sempre affaticato']},
      {ico:'🥛',txt:'Assumi proteine sufficienti (circa 1.2–1.6 g/kg peso)?',opts:['Sì, dieta proteica adeguata','Abbastanza, qualche carenza','Probabilmente insufficiente','Molto scarso, dieta povera di proteine']},
      {ico:'⚖️',txt:'Come valuti la tua forza e resistenza fisica nel quotidiano?',opts:['Ottima, non mi stanco facilmente','Buona per le attività normali','Limitata, fatico nelle attività normali','Molto ridotta, mi stanco subito']},
      {ico:'🧘',txt:'Pratichi stretching, yoga o mobilità articolare?',opts:['Sì, regolarmente','A volte, qualche sessione','Raramente','Mai']},
      {ico:'😴',txt:'Dormi 7–9 ore (fondamentale per il recupero muscolare)?',opts:['Sì, 7–9 ore di qualità','6–7 ore','5–6 ore','Meno di 5 ore o insonnia']},
      {ico:'🩺',txt:'Hai mai avuto infortuni muscolari, tendinei o articolari ricorrenti?',opts:['Mai','Un episodio isolato risolto','Occasionalmente (1–2/anno)','Frequenti, tendenza all\'infortunio']},
      {ico:'💊',txt:'Assumi creatina, aminoacidi o proteine in polvere se hai carenze?',opts:['Sì se necessario, dieta ottimale','A volte','Non integro ma la dieta è carente','Mai, con dieta chiaramente insufficiente']},
      {ico:'🏊',txt:'Fai attività cardiovascolare (cardio) regolare?',opts:['Sì, 3+ volte/settimana','1–2 volte a settimana','Raramente','Mai']},
    ],
    immune:[
      {ico:'🛡️',txt:'Quante volte ti ammali di influenza o forti raffreddori all\'anno?',opts:['Raramente (meno di 1 ogni 2 anni)','Una volta l\'anno','2–3 volte l\'anno','4 o più volte, sistema debole']},
      {ico:'😴',txt:'Dormi regolarmente 7–8 ore di qualità ogni notte?',opts:['Sì, sempre','Quasi sempre','Raramente','Mai, sonno molto carente']},
      {ico:'😤',txt:'Qual è il tuo livello di stress cronico?',opts:['Basso, ben gestito','Moderato','Alto e difficile da controllare','Molto alto, costante e debilitante']},
      {ico:'🥗',txt:'Mangi quotidianamente frutta, verdura e cibi ricchi di antiossidanti?',opts:['Sì, ad ogni pasto','Spesso','Raramente','Quasi mai, dieta povera']},
      {ico:'🌞',txt:'Ti esponi alla luce solare per almeno 20 min al giorno (vit. D)?',opts:['Sì, ogni giorno','Spesso','Raramente','Quasi mai, lavoro/vivo al chiuso']},
      {ico:'🏃',txt:'Pratichi attività fisica moderata regolare (stimola l\'immunità)?',opts:['Sì, 3+ volte/settimana','1–2 volte a settimana','Raramente','Mai']},
      {ico:'💊',txt:'Integri con vitamina D, C, zinco quando necessario?',opts:['Sì, regolarmente su indicazione','A volte','Raramente','Mai, nessuna integrazione']},
      {ico:'🍷',txt:'Consumi alcolici o tabacco (immunosoppressori)?',opts:['No, né alcol né fumo','Solo alcol occasionale','Fumo o alcol moderato-frequente','Fumo attivo + alcol regolare']},
      {ico:'🤧',txt:'Hai mai avuto malattie autoimmuni diagnosticate?',opts:['Mai','Episodio isolato risolto','Patologia autoimmune lieve','Patologia autoimmune cronica grave']},
      {ico:'😔',txt:'Ti senti spesso emotivamente esausto, svuotato, senza energia?',opts:['Mai','Raramente','Spesso','Quasi sempre, burnout cronico']},
    ],
    hormonal:[
      {ico:'⚖️',txt:'Il tuo umore è generalmente stabile nel corso della giornata?',opts:['Molto stabile, raramente sbalzi','Abbastanza stabile','Variabile, sbalzi frequenti','Molto instabile, sbalzi severi']},
      {ico:'😴',txt:'Hai difficoltà ad addormentarti o a mantenere il sonno?',opts:['No, nessuna difficoltà','Raramente','Spesso, quasi ogni settimana','Insonnia cronica quasi ogni notte']},
      {ico:'⚖️',txt:'Hai notato cambiamenti di peso inspiegabili (non legati alla dieta)?',opts:['No, peso stabile','Variazioni di 1–3 kg','Variazioni di 3–7 kg','Forti cambiamenti, oltre 7 kg']},
      {ico:'💆',txt:'Soffri di stanchezza cronica anche dopo una notte di sonno?',opts:['No, mi sveglio riposato','Raramente','Spesso, stanchezza persistente','Quasi sempre, debilitante']},
      {ico:'🌡️',txt:'Hai frequenti sensazioni di caldo o freddo eccessivo senza causa?',opts:['No, regolazione termica normale','Raramente','Spesso, fastidioso','Quasi sempre, molto disturbante']},
      {ico:'🩺',txt:'Hai mai avuto esami ormonali (TSH, cortisolo, testosterone/estrogeni) alterati?',opts:['Mai, sempre nella norma','Alterazione lieve e transitoria','Alterazione moderata in follow-up','Patologia ormonale nota in trattamento']},
      {ico:'💊',txt:'Assumi terapie ormonali, farmaci per la tiroide o contraccettivi ormonali?',opts:['No, nessuna terapia','In passato, ora sospesa','Attualmente in terapia ormonale','Terapia ormonale complessa cronica']},
      {ico:'😤',txt:'Sei esposto a stress cronico elevato (alza il cortisolo)?',opts:['No, stress basso','Moderato e gestito','Alto, difficile da gestire','Molto alto, costante da anni']},
      {ico:'🏃',txt:'Fai esercizio fisico regolare (regola gli ormoni)?',opts:['Sì, 3+ volte/settimana','1–2 volte a settimana','Raramente','Mai']},
      {ico:'🥗',txt:'Segui una dieta varia e ricca di micronutrienti (zinco, magnesio, vit. D)?',opts:['Sì, dieta ricca e varia','Abbastanza','Dieta povera e monotona','Molto carente, poco variata']},
    ],
    micro:[
      {ico:'🩸',txt:'Noti pesantezza, gonfiore o dolore alle gambe nel tardo pomeriggio?',opts:['Mai','Raramente, dopo lunghe giornate','Spesso, quasi ogni giorno','Sempre, fin dal mattino']},
      {ico:'🌡️',txt:'Hai spesso mani e piedi freddi anche in ambienti caldi?',opts:['Mai, circolazione ottima','Raramente','Spesso, quasi ogni giorno','Sempre, circolazione molto scarsa']},
      {ico:'💜',txt:'Hai vene varicose evidenti o numerosi capillari visibili sulle gambe?',opts:['No, gambe sane','Solo qualche capillare sottile','Capillari diffusi + vene varicose lievi','Vene varicose importanti o trattate']},
      {ico:'🏃',txt:'Fai attività fisica regolare che stimola la circolazione?',opts:['Sì, 3+ volte/settimana','1–2 volte a settimana','Raramente','Mai, vita completamente sedentaria']},
      {ico:'💊',txt:'Hai formicolii, torpore o intorpidimento frequente agli arti?',opts:['Mai','Raramente, episodi fugaci','Spesso','Quasi sempre o intensi']},
      {ico:'💧',txt:'Bevi almeno 1.5–2 litri di acqua al giorno?',opts:['Sì, sempre','Quasi sempre','Raramente','Quasi mai, bevo pochissimo']},
      {ico:'🪑',txt:'Resti seduto o in piedi fermo per molte ore consecutive?',opts:['No, mi muovo ogni 30–60 min','1–2 ore continue al massimo','3–4 ore senza muovermi','Oltre 4–6 ore immobile ogni giorno']},
      {ico:'🧦',txt:'Devi usare calze a compressione o hai prescrizione flebologica?',opts:['No, nessuna necessità','Mai prescritte ma le uso per comfort','Prescritte e uso occasionale','Prescritte e indispensabili ogni giorno']},
      {ico:'🥗',txt:'Segui una dieta ricca di bioflavonoidi, vitamina C e antiossidanti?',opts:['Sì, ogni giorno','Abbastanza','Raramente','Quasi mai']},
      {ico:'😴',txt:'Al mattino ti svegli con le gambe riposate e leggere?',opts:['Sempre, gambe perfette','Quasi sempre','Spesso pesanti al risveglio','Sempre pesanti, non recupero mai']},
    ],
  };

  const PRODS={renal:['Renovia','SoliD-3'],pulm:['SoliD-3','Trivase'],cardio:['Trivase','SoliD-3'],brain:['SoliD-3','Trivase'],metabol:['Renovia','SoliD-3'],liver:['Renovia','Trivase'],muscl:['SoliD-3','Trivase'],immune:['SoliD-3','Trivase'],hormonal:['SoliD-3','Renovia'],micro:['Trivase','Renovia']};

  let selMods=[],flatQs=[],answers=[],curQ=0,results={};

  function goTo(id){
    document.querySelectorAll('#bm-app .screen').forEach(s=>s.classList.remove('on'));
    document.getElementById(id).classList.add('on');
  }

  function buildModGrid(){
    const g=document.getElementById('modgrid');
    g.innerHTML='';
    MODS.forEach(m=>{
      const s=selMods.includes(m.id);
      const d=document.createElement('div');
      d.style.cssText=`background:${s?'#f0f5ff':'#f8faff'};border:${s?'2px solid #0050cc':'1.5px solid #e4eaf8'};border-radius:15px;padding:18px 14px;cursor:pointer;transition:all .2s;text-align:center;position:relative`;
      d.innerHTML=`<div style="font-size:26px;margin-bottom:9px">${m.ico}</div><div style="font-size:13px;font-weight:700;color:#0a1628;margin-bottom:3px">${m.name}</div><div style="font-size:11px;color:#8a9ab8">${m.desc}</div>${s?`<div style="position:absolute;top:9px;right:9px;width:20px;height:20px;border-radius:50%;background:#0050cc;display:flex;align-items:center;justify-content:center"><svg viewBox="0 0 10 8" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" width="10" height="8"><path d="M1 4l3 3 5-6"/></svg></div>`:''}`;
      d.onclick=()=>{if(s)selMods=selMods.filter(x=>x!==m.id);else selMods.push(m.id);buildModGrid();};
      g.appendChild(d);
    });
    const n=selMods.length;
    document.getElementById('selcount').textContent=n+(n===1?' selezionato':' selezionati');
    const btn=document.getElementById('btngo');
    btn.style.opacity=n>0?'1':'.3';
    btn.style.pointerEvents=n>0?'all':'none';
  }

  function startQuiz(){
    if(!selMods.length)return;
    flatQs=[];
    selMods.forEach(mid=>{
      const mod=MODS.find(m=>m.id===mid);
      QS[mid].forEach(q=>flatQs.push({...q,mid,mname:mod.name,mico:mod.ico}));
    });
    answers=new Array(flatQs.length).fill(null);
    curQ=0;renderQ();goTo('s2');
  }

  function renderQ(){
    const q=flatQs[curQ];
    const tag=document.getElementById('qtag');
    tag.textContent='';
    const ico=document.createElement('span');ico.textContent=q.mico;
    const lbl=document.createElement('span');lbl.textContent=q.mname;
    tag.appendChild(ico);tag.appendChild(lbl);
    document.getElementById('qnum').textContent=curQ+1;
    document.getElementById('qtot').textContent=flatQs.length;
    document.getElementById('qprog').style.width=Math.round((curQ+1)/flatQs.length*100)+'%';
    document.getElementById('qico').textContent=q.ico;
    document.getElementById('qtxt').textContent=q.txt;
    document.getElementById('btnbk').style.visibility=curQ===0?'hidden':'visible';
    const oc=document.getElementById('qopts');oc.innerHTML='';
    q.opts.forEach((opt,j)=>{
      const s=answers[curQ]===j;
      const d=document.createElement('div');
      d.style.cssText=`padding:13px 16px;background:${s?'#f0f5ff':'#f8faff'};border:${s?'2px solid #0050cc':'1.5px solid #e4eaf8'};border-radius:11px;font-size:14px;color:${s?'#0050cc':'#3a4a68'};cursor:pointer;display:flex;align-items:center;gap:12px;font-weight:${s?'600':'500'};transition:all .15s`;
      const radio=document.createElement('span');
      radio.style.cssText=`width:20px;height:20px;border-radius:50%;border:2px solid ${s?'#0050cc':'#d0daf0'};flex-shrink:0;display:flex;align-items:center;justify-content:center;background:${s?'#0050cc':'transparent'};transition:all .15s`;
      if(s){const dot=document.createElement('span');dot.style.cssText='width:7px;height:7px;border-radius:50%;background:#fff';radio.appendChild(dot);}
      d.appendChild(radio);d.appendChild(document.createTextNode(opt));
      d.onclick=()=>{answers[curQ]=j;renderQ();};
      oc.appendChild(d);
    });
    const btn=document.getElementById('btnnxt');
    const has=answers[curQ]!==null;
    btn.style.opacity=has?'1':'.3';
    btn.style.pointerEvents=has?'all':'none';
    const isLast=curQ===flatQs.length-1;
    btn.textContent=isLast?'Scopri il profilo →':'Continua →';
  }

  function prevQ(){if(curQ>0){curQ--;renderQ();}}
  function nextQ(){if(answers[curQ]===null)return;if(curQ<flatQs.length-1){curQ++;renderQ();}else runAnalysis();}

  function runAnalysis(){
    goTo('s3');
    const arc=document.getElementById('anarc');
    const circ=2*Math.PI*60;
    let p=0;
    const steps=[{id:'as0',at:25},{id:'as1',at:55},{id:'as2',at:80},{id:'as3',at:100}];
    function tick(){
      p+=1.1;if(p>100)p=100;
      arc.style.strokeDashoffset=circ-(p/100)*circ;
      document.getElementById('anapct').textContent=Math.round(p)+'%';
      steps.forEach((s,i)=>{
        const el=document.getElementById(s.id);
        const dot=el.querySelector('.asd');
        if(p>=s.at){el.style.color='#008850';if(dot){dot.style.background='#008850';dot.style.boxShadow='none';}}
        else if(p>=(steps[i-1]?.at||0)){el.style.color='#0050cc';if(dot){dot.style.background='#0050cc';dot.style.boxShadow='0 0 0 3px rgba(0,80,200,.15)';}}
      });
      if(p<100)requestAnimationFrame(tick);
      else setTimeout(buildResults,700);
    }
    requestAnimationFrame(tick);
  }

  function calcOrganAge(mid){
    const qs=flatQs.map((q,i)=>({q,i})).filter(x=>x.q.mid===mid);
    if(!qs.length)return 35;
    const avg=qs.reduce((acc,{q,i})=>acc+(answers[i]!==null?W[answers[i]]:W[0]),0)/qs.length;
    const deficit=100-avg;
    let age=22+deficit*0.42;
    if(deficit>30) age+=(deficit-30)*0.28;
    if(deficit>60) age+=(deficit-60)*0.25;
    return Math.round(age);
  }

  function calcGlobalScore(){
    const all=flatQs.map((q,i)=>answers[i]!==null?W[answers[i]]:W[0]);
    return Math.round(all.reduce((a,b)=>a+b,0)/all.length);
  }

  function buildResults(){
    selMods.forEach(mid=>{results[mid]=calcOrganAge(mid);});
    const gs=calcGlobalScore();
    const circ=2*Math.PI*28;
    const arcEl=document.getElementById('gscarc');
    arcEl.style.strokeDashoffset=circ-(gs/100)*circ;
    const col=gs>=80?'#008850':gs>=60?'#0050cc':gs>=40?'#e07020':'#c02050';
    arcEl.style.stroke=col;
    document.getElementById('gscval').textContent=gs;
    document.getElementById('gscval').style.color=col;
    document.getElementById('gsctext').textContent=
      gs>=80?'Profilo biologico eccellente — stile di vita ottimale.':
      gs>=60?'Buon equilibrio biologico con margini di miglioramento.':
      gs>=40?'Alcune aree mostrano segnali di attenzione significativi.':
      'Il tuo profilo biologico necessita di supporto strutturato.';
    const ol=document.getElementById('orglist');ol.innerHTML='';
    selMods.forEach(mid=>{
      const mod=MODS.find(m=>m.id===mid);
      const age=results[mid];
      const c=age<=30?'#008850':age<=38?'#0050cc':age<=50?'#e07020':'#c02050';
      const hint=age<=30?'Ottimale':age<=38?'Nella norma':age<=50?'Attenzione consigliata':'Supporto mirato urgente';
      const bw=Math.max(6,Math.min(98,Math.round((70-age)/(70-22)*100)));
      ol.innerHTML+=`<div style="background:#f8faff;border:1.5px solid #e4eaf8;border-radius:12px;padding:11px 13px">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:7px">
          <div style="font-size:12px;font-weight:700;color:#0a1628">${mod.ico} ${mod.name}</div>
          <div><span style="font-size:17px;font-weight:800;color:${c}">${age}</span><span style="font-size:10px;color:#8a9ab8"> aa bio</span></div>
        </div>
        <div style="height:3px;background:#e4eaf8;border-radius:2px;overflow:hidden;margin-bottom:5px"><div style="width:${bw}%;height:100%;background:${c};border-radius:2px"></div></div>
        <div style="font-size:10px;color:#8a9ab8;font-weight:600">${hint}</div>
      </div>`;
    });
    const prods=[...new Set(selMods.flatMap(mid=>PRODS[mid]||[]))].slice(0,3);
    document.getElementById('rpills').innerHTML=prods.map(p=>`<span style="background:#fff;border:1px solid #fad0a0;border-radius:20px;padding:4px 13px;font-size:12px;color:#b05800;font-weight:600">◈ ${p}</span>`).join('');
    const profile=gs>=80?'Equilibrio biologico eccellente':gs>=60?'Profilo biologico nella norma':gs>=40?'Profilo con aree di attenzione':'Profilo che necessita supporto';
    document.getElementById('rbadge').textContent=profile;
    document.getElementById('rtitle').textContent='Il tuo BioAge Report';
    document.getElementById('rdesc').textContent=gs>=60?'Il tuo profilo mostra segnali compatibili con un buon equilibrio biologico generale.':'Il tuo profilo mostra aree che potrebbero beneficiare di supporto mirato.';
    document.getElementById('rreco').textContent=gs>=80?'Il tuo equilibrio biologico è eccellente. Continua con il tuo stile di vita e ottimizza le aree con età biologica più alta.':gs>=60?'Il tuo profilo potrebbe beneficiare di un supporto mirato agli organi con età biologica più alta.':'Il tuo profilo necessita di un percorso strutturato di supporto biologico con attenzione agli organi critici.';
    goTo('s4');
  }

  function showPdf(){
    goTo('s5');
    document.getElementById('pdfspin').style.display='block';
    document.getElementById('pdftitle').textContent='Generazione report…';
    document.getElementById('pdfsub').textContent='Stiamo preparando il tuo BioAge Report personalizzato.';
    document.getElementById('pdfprev').style.display='none';
    document.getElementById('btndl').style.display='none';
    const now=new Date().toLocaleDateString('it-IT',{day:'2-digit',month:'long',year:'numeric'});
    document.getElementById('ppdate').textContent='Generato il '+now;
    const gs=calcGlobalScore();
    const grid=document.getElementById('ppgrid');
    grid.innerHTML=`<div style="background:#fff;border:1px solid #dce8ff;border-radius:8px;padding:9px 11px"><div style="font-size:9px;color:#8a9ab8;font-weight:700;text-transform:uppercase;letter-spacing:.07em;margin-bottom:2px">Score globale</div><div style="font-size:14px;font-weight:800;color:#0a1628">${gs}/100</div></div><div style="background:#fff;border:1px solid #dce8ff;border-radius:8px;padding:9px 11px"><div style="font-size:9px;color:#8a9ab8;font-weight:700;text-transform:uppercase;letter-spacing:.07em;margin-bottom:2px">Organi analizzati</div><div style="font-size:14px;font-weight:800;color:#0a1628">${selMods.length}</div></div>`+selMods.slice(0,4).map(mid=>{const mod=MODS.find(m=>m.id===mid);return`<div style="background:#fff;border:1px solid #dce8ff;border-radius:8px;padding:9px 11px"><div style="font-size:9px;color:#8a9ab8;font-weight:700;text-transform:uppercase;letter-spacing:.07em;margin-bottom:2px">${mod.name}</div><div style="font-size:14px;font-weight:800;color:#0a1628">${results[mid]} anni</div></div>`;}).join('');
    document.getElementById('ppbar').style.width=gs+'%';
    document.getElementById('ppnote').textContent=gs>=60?'Profilo biologico con segnali positivi.':'Alcune aree mostrano segnali di attenzione.';
    setTimeout(()=>{
      document.getElementById('pdfspin').style.display='none';
      document.getElementById('pdftitle').textContent='Il tuo BioAge Report è pronto';
      document.getElementById('pdfsub').textContent='Anteprima qui sotto. Premi per scaricarlo.';
      document.getElementById('pdfprev').style.display='block';
      document.getElementById('btndl').style.display='flex';
    },1800);
  }

  function doDownload(){
    if(typeof window.jspdf==='undefined'){
      alert('Libreria PDF non ancora caricata. Riprova tra un momento.');
      return;
    }
    const{jsPDF}=window.jspdf;
    const doc=new jsPDF({orientation:'portrait',unit:'mm',format:'a4'});
    const gs=calcGlobalScore();
    const now=new Date().toLocaleDateString('it-IT',{day:'2-digit',month:'long',year:'numeric'});
    doc.setFillColor(248,250,255);doc.rect(0,0,210,297,'F');
    doc.setFillColor(0,80,204);doc.rect(0,0,210,30,'F');
    doc.setTextColor(255,255,255);doc.setFontSize(9);doc.setFont(undefined,'bold');doc.text('BIOMEDIX — BIOAGE REPORT',20,12);
    doc.setFontSize(17);doc.text('Profilo Biologico Completo',20,23);
    doc.setTextColor(100,120,160);doc.setFontSize(9);doc.setFont(undefined,'normal');doc.text('Generato il '+now,20,38);
    doc.setTextColor(0,80,204);doc.setFontSize(12);doc.setFont(undefined,'bold');doc.text('Score biologico globale: '+gs+'/100',20,52);
    doc.setFillColor(0,80,204);doc.roundedRect(20,57,Math.round(170*gs/100),5,2,2,'F');
    doc.setFillColor(220,232,248);doc.roundedRect(20+Math.round(170*gs/100),57,170-Math.round(170*gs/100),5,2,2,'F');
    let y=74;
    doc.setTextColor(10,22,40);doc.setFontSize(13);doc.setFont(undefined,'bold');doc.text('Età biologiche per organo',20,y);y+=8;
    doc.setDrawColor(220,232,248);doc.setLineWidth(0.3);doc.line(20,y,190,y);y+=8;
    selMods.forEach(mid=>{
      const mod=MODS.find(m=>m.id===mid);const age=results[mid];
      const c=age<=30?[0,136,80]:age<=38?[0,80,204]:age<=50?[224,112,32]:[192,32,80];
      doc.setTextColor(60,74,106);doc.setFontSize(10);doc.setFont(undefined,'normal');doc.text(mod.name,20,y);
      doc.setTextColor(...c);doc.setFont(undefined,'bold');doc.text(age+' anni biologici',135,y);
      const hint=age<=30?'Ottimale':age<=38?'Nella norma':age<=50?'Attenzione':'Supporto urgente';
      doc.setTextColor(140,154,181);doc.setFontSize(8);doc.setFont(undefined,'normal');doc.text(hint,20,y+5);
      y+=14;if(y>265){doc.addPage();doc.setFillColor(248,250,255);doc.rect(0,0,210,297,'F');y=20;}
    });
    y+=4;doc.setDrawColor(220,232,248);doc.line(20,y,190,y);y+=8;
    doc.setTextColor(0,80,204);doc.setFontSize(11);doc.setFont(undefined,'bold');doc.text('Percorso consigliato',20,y);y+=8;
    const prods=[...new Set(selMods.flatMap(mid=>PRODS[mid]||[]))].slice(0,3);
    doc.setTextColor(60,74,106);doc.setFontSize(10);doc.setFont(undefined,'normal');
    prods.forEach(p=>{doc.text('  '+p,20,y);y+=7;});
    y+=10;doc.setTextColor(140,154,181);doc.setFontSize(8);
    doc.text('Nota: questo report è a scopo informativo e non costituisce diagnosi medica.',20,y);
    doc.text('Consulta sempre un medico per valutazioni cliniche specifiche.',20,y+5);
    doc.save('BioMedix-BioAge-Report.pdf');
  }

  function restart(){
    selMods=[];flatQs=[];answers=[];curQ=0;results={};
    document.querySelectorAll('#bm-app .ast').forEach(el=>{
      el.style.color='#c0cce0';
      const d=el.querySelector('.asd');
      if(d){d.style.background='#e4eaf8';d.style.boxShadow='none';}
    });
    const arc=document.getElementById('anarc');if(arc)arc.style.strokeDashoffset='377';
    const pct=document.getElementById('anapct');if(pct)pct.textContent='0%';
    buildModGrid();goTo('s0');
  }

  /* ─── ESPORTA API PUBBLICA ─── */
  Object.assign(window.BM, {goTo, startQuiz, prevQ, nextQ, showPdf, doDownload, restart});

  /* ─── INIT ─── */
  buildModGrid();

  /* ─── PARTICELLE ─── */
  (function(){
    const canvas=document.getElementById('pc');
    if(!canvas)return;
    const ctx=canvas.getContext('2d');
    let CW,CH,pts=[];
    function resize(){
      const r=canvas.parentElement.getBoundingClientRect();
      CW=canvas.width=r.width||680;
      CH=canvas.height=canvas.parentElement.offsetHeight||520;
    }
    function mkP(){return{x:Math.random()*CW,y:Math.random()*CH,vx:(Math.random()-.5)*.35,vy:(Math.random()-.5)*.35,r:Math.random()*1.8+.8,a:Math.random()*.5+.15};}
    function init(){resize();pts=[];for(let i=0;i<55;i++)pts.push(mkP());}
    function draw(){
      ctx.clearRect(0,0,CW,CH);
      pts.forEach(p=>{
        p.x+=p.vx;p.y+=p.vy;
        if(p.x<0)p.x=CW;if(p.x>CW)p.x=0;if(p.y<0)p.y=CH;if(p.y>CH)p.y=0;
        ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle=`rgba(0,100,220,${p.a})`;ctx.fill();
      });
      for(let i=0;i<pts.length;i++)for(let j=i+1;j<pts.length;j++){
        const dx=pts[j].x-pts[i].x,dy=pts[j].y-pts[i].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<85){ctx.beginPath();ctx.moveTo(pts[i].x,pts[i].y);ctx.lineTo(pts[j].x,pts[j].y);ctx.strokeStyle=`rgba(0,90,210,${.1*(1-d/85)})`;ctx.lineWidth=.5;ctx.stroke();}
      }
      requestAnimationFrame(draw);
    }
    init();draw();
    new ResizeObserver(()=>resize()).observe(canvas.parentElement);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
